export default __webpack_public_path__ + "static/media/pickup.fe1b6a24.svg";